import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import AssetType from "../../../containers/modules/accounting/asset-type";

export default function AssetTypeRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="asset-type"
      index
      element={
        <AccessControl
          name={"Asset Type List"}
          auth={authUser}
          component={() => <AssetType />}
        />
      }
    />
  );
}
